


















































import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "../../plugins/http";
import moment from "../../plugins/moment";

@Component
export default class Index extends Vue {
  tableData: any[] = [];
  pageNo: number = 1;
  total: number = 1;
  size: number = 1;
  date: any[] = [];
  loading: boolean = false;
  beginTime: number = null;
  endTime: number = null;
  statistics: any = {
    used: false,
    loading: false,
    data: {}
  };

  created() {
    this.date = [moment.getDayFromNow(-7), moment.getDayFromNow(0)];
    this.getList();
  }
  handlePageChange(val) {
    this.pageNo = val;
    this.getList();
  }
  getList() {
    this.loading = true;
    let [beginTime, endTime] = this.date;
    Axios.getSecret(`/api/pay/transaction/page`, {
      pageNo: this.pageNo,
      beginTime,
      endTime
    }).then(
      ({
        data: {
          data: { records, total, size },
          status,
          msg
        }
      }) => {
        if (status === 200) {
          this.tableData = records;
          this.total = total;
          this.size = size;
        } else {
          this.$message(msg);
        }
        this.loading = false;
      }
    );
  }
  getStatistics() {
    this.statistics.used = true;
    this.statistics.loading = true;
    let [beginTime, endTime] = this.date;

    Axios.getSecret(`/api/pay/transaction/statistics`, {
      beginTime,
      endTime
    }).then(res => {
      if (res.data.status === 200) {
        this.statistics.loading = false;
        this.statistics.data = res.data.data;
      } else {
        this.$message(res.data.msg);
      }
    });
  }
}
